import { Interval } from 'luxon';

export default function calculateDateIntervals(startDate, endDate, groupPeriod) {
  return Interval.fromDateTimes(startDate, endDate)
                      .splitBy({ [groupPeriod]: 1 })
                      .map((date) => date.start.toISODate());
}
